import { AssetClassType } from "../models/asset-class-type";
import * as participantRepo from "../repositories/participant";

export async function getAssetClasses(): Promise<AssetClassType[]> {
  return participantRepo.get("/asset-classes");
}
